<style scoped>
.excel-span {
  height: 24px;
  line-height: 24px;
  display: inline-block;
  padding: 1px 8px 1px 8px;
  border-radius: 4px;
  background-color: #f4f4f5;
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
</style>
<template>
  <div>
    <el-dialog :visible.sync="visible" :title="title" append-to-body="append-to-body">
      <div :class="[tableData.length > 0 ? 'dialog-scroller' : '']" style="display: flex;flex-direction: column;">
        <el-form size="mini" :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button size="mini" icon="el-icon-document-add" type="primary" @click="exportModel">
              {{ $t('xiazaimuban') }}
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button :loading="uploadLoading" size="mini" type="default" icon="el-icon-plus" @click="handleUpload">
              {{ $t('piliangshangchuan') }}
            </el-button>
          </el-form-item>
        </el-form>
        <!--上传-->
        <div>
          <input id="matterFileInput" ref="excel-upload-input" class="excel-upload-input" type="file" multiple accept=".xlsx, .xls" @change="handleClick" />
        </div>
        <!--excel-->
        <div>
          <span v-for="(item, index) in excel" :key="index" class="excel-span" closable size="mini">
            <i class="el-icon-link" />
            <span>{{ item }}</span>
            <i style="margin-left: 5px" class="el-icon-close" @click="deleteExcel(item)" />
          </span>
        </div>
        <!--表格-->
        <div ref="table" style="flex: 1;margin-top: 10px;">
          <el-table stripe :max-height="tableHeight" :data="tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)" border size="mini" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
            <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop" :show-overflow-tooltip="true" :label="item.label" :width="item.width" :sortable="item.sortable">
              <template slot-scope="scope">
                <span>{{ scope.row[item.prop] === '' ? '-' : scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 20px;">
          <el-pagination v-if="tableData.length > 0" style="display: flex;float: right;" background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :pagerCount="5" :page-size="pagination.pageSize" layout="total,sizes,prev,pager,next" :total="tableData.length" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="visible = false">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" size="mini" :loading="saveLoading" @click="importData" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '报工记录-批量导入报工' } }">{{ $t('baocun') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saveLoading: false,
      uploadLoading: false,
      excel: [],
      tableHeight: 0,
      tableData: [],
      tableColumn: [
        {
          label: this.$t('daorubaogao'),
          prop: 'result',
          width: 125
        },
        {
          label: this.$t('shengchangongdanhao'),
          prop: 'woNo',
          width: 150
        },
        {
          label: this.$t('gongxumiaoshu'),
          prop: 'woProcedureDesc',
          width: 150
        },
        {
          label: this.$t('baogongriqi'),
          prop: 'reportDate',
          width: 120
        },
        {
          label: this.$t('baogongbanci'),
          prop: 'shift',
          width: 120
        },
        {
          label: this.$t('dangbanbaogongshuliang'),
          prop: 'curShiftQuantity',
          width: 120
        },
        {
          label: this.$t('dangbanbuliangshuliang'),
          prop: 'curShiftBadQuantity'
        }
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      visible: false,
      title: this.$t('piliangdaorubaogong')
    };
  },
  watch: {
    show: {
      handler(n) {
        this.visible = n;
        if (n == true) {
          this.countTableHeight();
        }
        if (n == false) {
          this.currentPage = 1;
        }
      },
      immediate: false
    },
    visible: {
      handler(n) {
        if (!n) {
          this.$emit('update:show', false);
          this.tableData = [];
          this.excel = [];
          this.$refs['excel-upload-input'].value = null;
        }
      },
      immediate: false
    }
  },
  methods: {
    // 下载模板
    exportModel() {
      window.open((process.env.NODE_ENV === 'development' ? global.URL_DEV_API_BASE_DOMAIN : process.env.VUE_APP_SERVER === 'preview' ? global.URL_PRE_API_BASE_DOMAIN : global.URL_PROD_API_BASE_DOMAIN) + '/web/customer/files/viewFileByFileId/piliangdaorubaogongmuban');
    },
    importData() {
      const data = this.deepClone([...this.tableData]);
      if (data.length <= 0) {
        this.$message.warning(this.$t('qingshangchuanwenjian'));
        return;
      }
      this.saveLoading = true;
      for (let i = 0; i < data.length; i++) {
        data[i]['woNo'] ? data[i]['woNo'] : (data[i]['woNo'] = '');
        data[i]['woProcedureDesc'] ? data[i]['woProcedureDesc'] : (data[i]['woProcedureDesc'] = '');
        data[i]['reportDate'] ? data[i]['reportDate'] : (data[i]['reportDate'] = '');
        data[i]['shift'] ? data[i]['shift'] : (data[i]['shift'] = '');
        data[i]['curShiftQuantity'] ? data[i]['curShiftQuantity'] : (data[i]['curShiftQuantity'] = 0);
        data[i]['curShiftBadQuantity'] ? data[i]['curShiftBadQuantity'] : (data[i]['curShiftBadQuantity'] = 0);
        delete data[i]['excel'];
      }
      if (this.listLength == null || this.listLength.length == 0) {
        return this.http
          .post('/web/production/woreportrecord/batchWoReport?onlyValidate=false', data)
          .then(res => {
            this.$message.success(this.$t(res.msg));
            this.show = false;
            // 刷新主页面列表(参数要与被调用得页面$on()中名称对应)
            this.utils.event_hub.$emit('WEB_WORK_REPORT_REFRESH');
          })
          .catch(error => {
            this.$message.error(error);
          })
          .finally(() => {
            this.saveLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
        this.saveLoading = false;
      }
    },
    /**
     * 显示上传弹框
     */
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    /**
     * 点击上传
     * @param e
     * @returns {Promise<void>}
     */
    async handleClick(e) {
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        this.beforeUpload(files[i]);
      }

      this.uploadLoading = true;
      document.getElementById('matterFileInput').value = '';
      setTimeout(() => {
        let data = [...this.tableData];
        for (let i = 0; i < data.length; i++) {
          data[i]['woNo'] ? data[i]['woNo'] : (data[i]['woNo'] = '');
          data[i]['woProcedureDesc'] ? data[i]['woProcedureDesc'] : (data[i]['woProcedureDesc'] = '');
          data[i]['reportDate'] ? data[i]['reportDate'] : (data[i]['reportDate'] = '');
          data[i]['shift'] ? data[i]['shift'] : (data[i]['shift'] = '');
          data[i]['curShiftQuantity'] ? data[i]['curShiftQuantity'] : (data[i]['curShiftQuantity'] = 0);
          data[i]['curShiftBadQuantity'] ? data[i]['curShiftBadQuantity'] : (data[i]['curShiftBadQuantity'] = 0);
          delete data[i]['excel'];
        }
        this.http
          .post('/web/production/woreportrecord/batchWoReport?onlyValidate=true', data)
          .then(response => {
            this.listLength = response.data.validateItems;
            if (response.data.validateItems && response.data.validateItems.length > 0) {
              const list = response.data.validateItems;
              for (let i = 0; i < list.length; i++) {
                this.$set(this.tableData[Number(list[i]['index'])], 'result', list[i]['items'].join(','));
              }
            }
          })
          .catch(err => {
            this.$message.error(err);
          })
          .finally(() => {
            this.uploadLoading = false;
          });
      }, 800);
    },
    /**
     * 上传前
     * @param rawFile
     * @returns {boolean}
     */
    beforeUpload(rawFile) {
      if (this.excel.length < 2) {
        //this.$refs['excel-upload-input'].value = null
      }
      if (!this.isExcel(rawFile)) {
        this.$message.error(this.$t('zhizhichi') + '.xlxs,xls,csv' + this.$t('geshiwenjian'));
        return false;
      }
      if (this.excel.length > 2) {
        this.$message.error(this.$t('zuidazhichi') + '3' + this.$t('geexcelwenjian'));
        return false;
      }
      if (this.excel.includes(rawFile.name)) {
        this.$message.error(rawFile.name + this.$t('wenjianyicunzai'));
        return false;
      }
      this.readerData(rawFile);
    },

    /**
     * 解析excel
     * @param rawFile
     */
    readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = e => {
        const name = rawFile.name;
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: 'array',
          cellDates: true
        });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const header = this.getHeaderRow(worksheet);
        const results = XLSX.utils.sheet_to_json(worksheet);
        this.generateData({
          header,
          results,
          name
        });
      };
      reader.readAsArrayBuffer(rawFile);
    },
    /**
     * 获取excel头部
     * @param sheet
     * @returns {[]}
     */
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet['!ref']);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell =
          sheet[
          XLSX.utils.encode_cell({
            c: C,
            r: R
          })
          ];
        let hdr = 'UNKNOWN ' + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * 数据解析
     * @param header
     * @param results
     * @param name
     */
    generateData({ header, results, name }) {
      const data = [];
      if (results.length > 0) {
        for (let i = 0; i < results.length; i++) {
          const item = {
            excel: name
          };
          for (let j = 0; j < this.tableColumn.length; j++) {
            if (results[i][this.tableColumn[j]['label']]) {
              this.$set(item, this.tableColumn[j]['prop'], results[i][this.tableColumn[j]['label']]);
            }
          }
          // 日期类型
          if (item['reportDate']) {
            item['reportDate'] = this.dayjs(item['reportDate']).format('YYYY-MM-DD');
          }
          if (!item['curShiftQuantity']) {
            item['curShiftQuantity'] = 0;
          }
          if (!item['curShiftBadQuantity']) {
            item['curShiftBadQuantity'] = 0;
          }

          data.push(item);
        }
      }
      this.tableData = this.tableData.concat(data);
      for (let i = 0; i < this.tableData.length; i++) {
        this.$set(this.tableData[i], 'rid', i + 1);
      }
      this.excel.push(name);
      this.countTableHeight();
    },
    /**
     * 判断是否为excel文件
     * @param file
     * @returns {boolean}
     */
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    },
    /**
     * 刪除excel
     * @param name
     */
    deleteExcel(name) {
      this.excel = this.excel.filter(item => {
        return item !== name;
      });
      this.tableData = this.tableData.filter(item => {
        return item.excel !== name;
      });
      console.log('excel:', this.excel);
      console.log('tableData:', this.tableData);
      console.log('tableColumn', this.tableColumn);
    },
    countTableHeight() {
      this.tableHeight = 0;
      this.$nextTick(() => {
        if (this.tableData.length > 0) {
          this.tableHeight = this.$refs.table.offsetHeight - 10;
        } else {
          this.tableHeight = 110;
        }
      });
    },
    //深拷贝
    deepClone(data) {
      const type = this.judgeType(data);
      let obj;
      if (type === 'array') {
        obj = [];
      } else if (type === 'object') {
        obj = {};
      } else {
        // 不再具有下一层次
        return data;
      }
      if (type === 'array') {
        // eslint-disable-next-line
        for (let i = 0, len = data.length; i < len; i++) {
          obj.push(this.deepClone(data[i]));
        }
      } else if (type === 'object') {
        // 对原型上的方法也拷贝了....
        // eslint-disable-next-line
        for (const key in data) {
          obj[key] = this.deepClone(data[key]);
        }
      }
      return obj;
    },
    judgeType(obj) {
      // tostring会返回对应不同的标签的构造函数
      const toString = Object.prototype.toString;
      const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
      };
      if (obj instanceof Element) {
        return 'element';
      }
      return map[toString.call(obj)];
    }
  }
};
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}

.drop {
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
